import { render, staticRenderFns } from "./HandsUp.vue?vue&type=template&id=f9964efc&lang=pug&"
import script from "./HandsUp.vue?vue&type=script&lang=js&"
export * from "./HandsUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports